// Fri fragt-bar - Atlantic Pouches (design G)
// --------------------------------------
// Kompakt kort: beloeb til fri fragt til venstre, "forbrugt / graense" til
// hoejre, tynd progress-bar under. Den animerede lastbil, konfettien og
// procent-tallet er vaek: procenten stod to gange, og beloebet er det kunden
// handler paa.
//
// Taersklerne kommer fra data-free-shipping-XX / data-extra-free-shipping-XX,
// dvs. Temaindstillinger per marked.
//
// RETTET undervejs: den gamle taerskel-tabel var skrevet ud i haanden, og 11 af
// 18 lande (US, SE, BE, AT, SI, IT, IE, CH, PT, CZ, CA) laeste ved en
// copy-paste-fejl data-free-shipping-LV. US/IT/CH/CA viste derfor 75 i stedet
// for deres rigtige 100, og ingen af de 11 fik deres premium-taerskel vist.
// Den generiske _thresholds()-loekke kan ikke lave den fejl.

if (typeof ShippingNotice !== 'function') {

  var COUNTRY_KEYS = ['LT','DE','FR','HU','LV','US','SE','BE','AT','SI','IT','IE','CH','PT','CZ','CA'];

  // Flaget skal ligge uden for klassen. <shipping-notice> lever inde i
  // #AjaxCartForm, som udskiftes ved hver kurv-opdatering - en instans-variabel
  // ville derfor altid vaere false, og baren ville aldrig animere, men i stedet
  // "vokse" forfra hver gang kurven blev aabnet eller aendret.
  if (typeof window.__esShipRendered === 'undefined') window.__esShipRendered = false;

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    _locale(key, fallbackKey) {
      var l = (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales) || {};
      return l[key] || (fallbackKey ? l[fallbackKey] : '') || '';
    }

    _thresholds(prefix) {
      var out = { DEFAULT: Number(this.getAttribute('data-' + prefix + '-default')) / 100 || 0 };
      COUNTRY_KEYS.forEach((cc) => {
        out[cc] = Number(this.getAttribute('data-' + prefix + '-' + cc)) / 100 || 0;
      });
      return out;
    }

    async init() {
      const cartTotal = Number(this.getAttribute('data-cart-total-amount')) / 100; // til euro
      let countryCode = this.getAttribute('data-country-code');

      if (!countryCode) {
        countryCode = await this.getCountryCodeFromGeolocation();
        countryCode = countryCode.toUpperCase();
      }

      // Atlantic har INGEN DK/FI-undtagelse: brandet betjener Finland, og
      // synligheden styres i forvejen af allowedCountries-gaten i cart-form.

      const freeShippingThresholds = this._thresholds('free-shipping');
      const extraFreeShippingThresholds = this._thresholds('extra-free-shipping');

      const freeShippingThreshold = freeShippingThresholds[countryCode] || freeShippingThresholds.DEFAULT;
      const extraFreeShippingThreshold = extraFreeShippingThresholds[countryCode] || extraFreeShippingThresholds.DEFAULT;

      let message = '';
      let done = false;
      let progress = 0;
      let threshold = freeShippingThreshold;

      if (freeShippingThreshold > 0 && cartTotal < freeShippingThreshold) {
        message = this._locale('shipping_notice_to_free', 'shipping_notice_remaining_to_free')
          .replace('{{ remaining_amount }}', this._formatMoney((freeShippingThreshold - cartTotal) * 100, KROWN.settings.shop_money_format));
        progress = (cartTotal / freeShippingThreshold) * 100;
        threshold = freeShippingThreshold;
      } else if (extraFreeShippingThreshold > 0 && cartTotal < extraFreeShippingThreshold) {
        message = this._locale('shipping_notice_to_extra_free', 'shipping_notice_remaining_to_extra_free')
          .replace('{{ remaining_amount }}', this._formatMoney((extraFreeShippingThreshold - cartTotal) * 100, KROWN.settings.shop_money_format));
        progress = (cartTotal / extraFreeShippingThreshold) * 100;
        threshold = extraFreeShippingThreshold;
      } else if (extraFreeShippingThreshold > 0 && cartTotal >= extraFreeShippingThreshold) {
        message = this._locale('cart_free_shipping_unlocked', 'shipping_notice_eligible_for_extra_free');
        done = true;
        this.showFreebar();
      } else if (freeShippingThreshold > 0 && cartTotal >= freeShippingThreshold) {
        message = this._locale('cart_free_shipping_unlocked', 'shipping_notice_eligible_for_free');
        done = true;
      }

      // Ingen graense paa markedet -> sektionen renderes ikke.
      if (message === '') {
        this.style.display = 'none';
        this.innerHTML = '';
        return;
      }

      const html = done
        ? '<div class="cart-g-ship cart-g-ship--done">'
          + '<div class="cart-g-ship__row"><span class="cart-g-ship__msg">' + message + '</span></div>'
          + '</div>'
        : '<div class="cart-g-ship' + (window.__esShipRendered ? ' cart-g-ship--animate' : '') + '">'
          + '<div class="cart-g-ship__row">'
          + '<span class="cart-g-ship__msg">' + message + '</span>'
          + '<span class="cart-g-ship__amounts">'
          + this._formatMoney(cartTotal * 100, KROWN.settings.shop_money_format)
          + ' / ' + this._formatMoney(threshold * 100, KROWN.settings.shop_money_format)
          + '</span>'
          + '</div>'
          + '<div class="cart-g-ship__track"><span class="cart-g-ship__fill"></span></div>'
          + '</div>';

      this.innerHTML = html;
      this.style.display = 'block';

      // Bredden saettes efter indsaettelsen, saa transitionen har noget at gaa fra.
      // Foerste render er uanimeret; ellers "vokser" baren hver gang kurven aabnes.
      const fill = this.querySelector('.cart-g-ship__fill');
      if (fill) {
        const width = Math.max(0, Math.min(progress, 100)) + '%';
        if (window.__esShipRendered) {
          requestAnimationFrame(() => { fill.style.width = width; });
        } else {
          fill.style.width = width;
        }
      }
      window.__esShipRendered = true;
    }

    // Landekoden kommer fra window.ESGeo (snippets/geo-country.liquid), som
    // bruger Shopifys egen /browsing_context_suggestions.json. Tidligere laa
    // der et direkte ipapi.co-kald her -- det blev rate-limited (429) og fik
    // komponenten til at falde tilbage til DEFAULT-taersklerne.
    async getCountryCodeFromGeolocation() {
      return new Promise((resolve) => {
        if (window.ESGeo && typeof window.ESGeo.get === 'function') {
          window.ESGeo.get((cc) => resolve(cc || 'DEFAULT'));
          return;
        }
        console.warn('ESGeo ikke indlaest -- render geo-country foer denne komponent.');
        resolve('DEFAULT');
      });
    }

    showFreebar() {
      const freebar = document.querySelector('.freebar');
      if (freebar) {
        freebar.style.display = 'block';
      }
    }

    _formatMoney(cents, format) {
      // UK-markedet: display-only GBP (kunden betaler EUR) — se ESGBP i theme.liquid
      if (window.ESGBP && window.ESGBP.enabled) {
        return window.ESGBP.format(cents);
      }
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get('shipping-notice') == 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
